export const One_Third_Page = `
<h3>Image Copy Block</h3>
<hr />
<article id="one-third-page-right">
  <div class="row image-copy-block">
    <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 d-flex justify-content-xl-center justify-content-lg-center justify-content-md-start justify-content-sm-center justify-content-center image">
      <img src="https://pdpdevelopment.blob.core.windows.net/roadrunner-cdn/courses/images/how-it-works_lifetime.svg" style="z-index:0;" />
    </div>
    <div class="col-xl-8 col-lg-8 col-md-12 col-sm-12 d-flex justify-content-xl-center justify-content-lg-center justify-content-md-start justify-content-sm-center justify-content-start align-self-lg-center copy">
      Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
    </div>
  </div>
</article>

<article id="one-third-page-left">
  <div class="row image-copy-block">
    <div class="col-xl-8 col-lg-8 col-md-12 col-sm-12 d-flex justify-content-xl-center justify-content-lg-center justify-content-md-start justify-content-sm-center justify-content-start align-self-lg-center copy">
      Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
    </div>
    <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 d-flex justify-content-xl-center justify-content-lg-center justify-content-md-start justify-content-sm-center justify-content-center image">
      <img src="https://pdpdevelopment.blob.core.windows.net/roadrunner-cdn/courses/images/how-it-works_lifetime.svg" style="z-index:0;" />
    </div>
  </div>
</article>
`;
